import {compose, lifecycle} from 'recompose';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {getFeature} from '@webex/redux-module-features';
import {connectToMercury} from '@webex/redux-module-mercury';
import {
  FEATURES_DEVELOPER,
  FEATURES_WIDGET_ADAPTIVE_CARD
} from '@webex/react-component-utils';

import {updateWidgetState} from '../actions';
import getMessageWidgetProps from '../selector';

function getFeatures(props) {
  const {
    sparkInstance,
    widgetMessage
  } = props;

  const hasFetchedAdaptiveCardFeature = widgetMessage.get('hasFetchedAdaptiveCardFeature');

  // Initial fetching of adaptive card feature
  if (!hasFetchedAdaptiveCardFeature) {
    props.updateWidgetState({
      hasFetchedAdaptiveCardFeature: true
    });

    props.getFeature(FEATURES_DEVELOPER, FEATURES_WIDGET_ADAPTIVE_CARD, sparkInstance);
  }
}

export function setup(props) {
  const {
    sparkInstance,
    sparkState
  } = props;

  if (sparkInstance
    && sparkState.authenticated
    && sparkState.registered
    && !sparkState.hasError
  ) {
    getFeatures(props);
  }
}

export default compose(
  connect(
    getMessageWidgetProps,
    (dispatch) => bindActionCreators({
      connectToMercury,
      getFeature,
      updateWidgetState
    }, dispatch)
  ),
  lifecycle({
    componentWillMount() {
      setup(this.props);
    },
    shouldComponentUpdate(nextProps) {
      return nextProps !== this.props;
    },
    componentWillReceiveProps(nextProps) {
      setup(nextProps, this.props);
    }
  })
);
